import { Controller } from "@hotwired/stimulus"

// Handles QR code photo preview and removal for payment methods
export default class extends Controller {
  static targets = ["input", "preview", "existingPhoto", "removeCheckbox", "previewContainer"]

  connect() {
    // Check if remove checkbox is checked on load
    if (this.hasRemoveCheckboxTarget && this.removeCheckboxTarget.checked) {
      this.toggleExistingPhoto()
    }
  }

  preview(event) {
    const file = event.target.files[0]

    if (file && file.type.startsWith('image/')) {
      const reader = new FileReader()

      reader.onload = (e) => {
        // Show preview container and update image
        if (this.hasPreviewContainerTarget) {
          this.previewContainerTarget.classList.remove('hidden')
        }

        if (this.hasPreviewTarget) {
          this.previewTarget.src = e.target.result
          this.previewTarget.classList.remove('hidden')
        }

        // Hide existing photo section when new file selected
        if (this.hasExistingPhotoTarget) {
          this.existingPhotoTarget.classList.add('hidden')
        }

        // Uncheck remove checkbox if checked
        if (this.hasRemoveCheckboxTarget) {
          this.removeCheckboxTarget.checked = false
        }
      }

      reader.readAsDataURL(file)
    } else if (file) {
      alert('Please select a valid image file (JPG, PNG, WebP)')
      event.target.value = ''
    }
  }

  toggleRemove(event) {
    this.toggleExistingPhoto()
  }

  toggleExistingPhoto() {
    if (this.hasExistingPhotoTarget) {
      if (this.removeCheckboxTarget.checked) {
        this.existingPhotoTarget.classList.add('opacity-50')
      } else {
        this.existingPhotoTarget.classList.remove('opacity-50')
      }
    }
  }

  // Reset preview if file input is cleared
  reset() {
    if (this.hasPreviewTarget) {
      this.previewTarget.classList.add('hidden')
      this.previewTarget.src = ''
    }

    if (this.hasPreviewContainerTarget) {
      this.previewContainerTarget.classList.add('hidden')
    }

    if (this.hasExistingPhotoTarget) {
      this.existingPhotoTarget.classList.remove('hidden', 'opacity-50')
    }

    if (this.hasRemoveCheckboxTarget) {
      this.removeCheckboxTarget.checked = false
    }
  }
}
